<div class="wrapper">
  <header class="d-xl-none mb-4 text-center" *ngIf="!isAuthorized">
    <cf-text size="sm" weight="500">
      {{ "booking.unauthorized_availability_text" | translate }}
    </cf-text>
    <a cf-link class="d-block mt-2" routerLink="/auth/sign-up" target="_blank">
      {{ "booking.connect_calendar" | translate }}
    </a>
  </header>

  @if (!hasFreeSlots) {
    <div class="bg-yellow-10 p-3">
      <cf-text size="sm" weight="500">
        {{ "booking.no_any_available_slots" | translate }}
      </cf-text>
    </div>
  } @else if (timeslot.has_daily_booking_limit_reached_slots && !troubleshoot) {
    <div class="bg-yellow-10 p-3">
      <cf-text size="sm" weight="500">
        {{ "booking.no_any_available_slots_text" | translate }}
      </cf-text>

      @if (timeslots.length > 1) {
        <a cf-link size="sm" class="d-block mt-2" (click)="emitNextSlot.emit()">
          {{ "booking.try_next_available_day" | translate }}
        </a>
      }
    </div>
  } @else {
    <header class="mb-2">
      <cf-time-settings
        *ngIf="timezoneSetting"
        [disabled]="disableTimezone"
        class="tw:mb-4"
        appendTo="cf-booking, cf-reschedule-booking"
        [timezone]="$any(timezone)"
        [time_format]="_timeFormat"
        [date]="timeslot.date"
        (formatChange)="formatChange($event)"
        (timezoneChange)="emitTimezone.emit($event)"
      ></cf-time-settings>
      <cf-duration-toggle
        toggleType="yellow"
        [switchToDropdown]="false"
        #durationToggleComponent
        [availableDurations]="durations"
        [duration]="duration"
        [skipScroll]="isPreview"
        (emitDurationChange)="onDurationChange($event)"
        [cutMin]="true"
      ></cf-duration-toggle>
    </header>
    <section class="hide-scrollbar" (scroll)="onScroll()">
      @if (timeSlots) {
        <cf-text class="no-data-text mt-3" *ngIf="!timeSlots.length">
          {{ "booking.no_available_slots" | translate }}
        </cf-text>

        @for (time of timeSlots; track $index) {
          <ng-container *ngIf="time.start as start">
            <div
              class="timeslot d-flex align-items-center mt-2"
              *ngIf="(!troubleshoot && time.is_available) || troubleshoot"
            >
              <cf-button
                color="timeslot"
                [class.busy]="checkBusyState(time.start) && !isFormer(time.start, durationToggleComponent.minutes)"
                class="tw:w-full"
                (click)="time.is_available ? focusTime(time.start) : null"
                [className]="selectedSlot === time.start ? 'active' : ''"
                [class.unavailable]="!time.is_available"
              >
                {{ start | dateFormat: timeFormat : true }}
                @if (isFormer(time.start, durationToggleComponent.minutes)) {
                  <div class="dot text-danger position-relative tw:ml-2"></div>
                }

                @if (!time.is_available) {
                  <cf-text color="red-50" class="my-1">
                    {{ "unavailable" | translate }}
                  </cf-text>
                  <div class="d-flex flex-wrap gap-2">
                    @for (reason of time.reasons; track $index) {
                      <div
                        class="chip"
                        [ngbPopover]="reason | unavailableReasonTranslate: true"
                        [popoverTitle]="reason | unavailableReasonTranslate"
                        [disablePopover]="time.is_available"
                        #p="ngbPopover"
                        triggers="hover click"
                        placement="top"
                      >
                        {{ reason | unavailableReasonTranslate }}
                      </div>
                    }
                  </div>
                }
              </cf-button>

              <cf-button
                color="primary"
                class="ms-2"
                *ngIf="selectedSlot === time.start"
                (click)="
                  emitConfirm.emit({
                    time: time.start,
                    duration: durationToggleComponent.minutes,
                  })
                "
                isLoadingBtn
                disableOnRequest
              >
                {{ "confirm" | translate }}
              </cf-button>
            </div>
          </ng-container>

          @if (isTouch) {
            @if (highlightedEvents(time.start); as events) {
              <div class="card" *ngFor="let event of events">
                <cf-text size="sm" weight="500" color="grey-70">
                  {{ "booking.you_have_meeting_at" | translate }}
                  {{ event.start | dateFormat: timeFormat }} -
                  {{ event.end | dateFormat: timeFormat }}
                </cf-text>
                <cf-text weight="500" color="grey-70" class="mt-1">
                  {{ event.name }}
                </cf-text>
              </div>
            }
          }
        }
      }
    </section>
    <footer class="mt-4 text-center">
      <cf-text size="sm">
        {{ "booking.we_used_information_from_your_calendar_to_show_when_you_are_busy" | translate }}
      </cf-text>
    </footer>
  }
</div>
